import { css, jsx } from '@emotion/react';
import { useEffect } from 'react';
import { ListBoxItem } from 'react-aria-components';
import { Typography, Colors, Icon } from '@zapier/design-system';
import { useSelectContext } from './SelectContext.es.js';

const SelectItemStyles = css(Object.assign(Object.assign({}, Typography.Body2), { padding: "var(--zds-space-6, 10px) var(--zds-space-8, 10px)", borderRadius: "var(--zds-radius-small, 3)", display: "flex", alignItems: "center", gap: "var(--zds-space-8, 8px)", color: `var(--zds-text-default, ${Colors.GrayWarm9})`, outline: "none", userSelect: "none", cursor: "pointer", '&[data-size="large"]': {
  padding: "var(--zds-space-12, 10px) var(--zds-space-8, 10px)"
}, '&[data-size="compact"]': Object.assign({}, Typography.MinimalPrint2), '&[data-state="checked"]': {
  color: `var(--zds-ui-primary-strongest, ${Colors.GrayWarm10})`,
  backgroundColor: `var(--zds-ui-primary-weaker, ${Colors.GrayWarm2})`,
  outline: "none"
}, "&[data-disabled]": {
  backgroundColor: `var(--zds-background-stronger)`,
  color: `var(--zds-text-weakest, ${Colors.GrayWarm5})`,
  cursor: "not-allowed"
}, "&[data-focused], &[data-focus-visible]": {
  backgroundColor: `var(--zds-ui-primary-weakest, ${Colors.UiPrimaryWeakest})`,
  color: `var(--zds-ui-primary-strongest, ${Colors.UiPrimaryStrongest})`
} }));
const SelectItem = ({ children, className, isDisabled = false, iconName, size, textValue, value }) => {
  const { registerDisabledItem } = useSelectContext();
  useEffect(() => {
    if (isDisabled) {
      registerDisabledItem(value || "");
    }
  }, [isDisabled, value, registerDisabledItem]);
  return jsx(
    ListBoxItem,
    { css: SelectItemStyles, className, "data-size": size, "data-zds": true, id: value, textValue },
    iconName && jsx(Icon, { name: iconName, size: 16 }),
    children
  );
};

export { SelectItem };
//# sourceMappingURL=SelectItem.es.js.map
